import { PersonalInfo } from 'src/components/PrincipalForm/PrincipalForm';

export const PrincipalModalTitles = {
    ADD: 'Add Principal',
    EDIT: 'Edit Principal',
};

export const handlePrincipalSubmit = (
    formik: {
        principal: PersonalInfo;
        newBillingContact?: number;
    },
    data
) => {
    const {
        merchantDashboard,
        principalModalTitle,
        principalIndex,
        setNewBillingContactMessage,
        updatePrincipals,
    } = data;
    const { merchantInformation, id } = merchantDashboard.application;
    let currentPrincipals = [...merchantInformation.principals];
    if (principalModalTitle === PrincipalModalTitles.EDIT) {
        // Find the existing billing contact
        const oldBillingContactIndex = currentPrincipals.findIndex((p) => {
            return p.isBillingContact;
        });

        // Check if a new billing contact is selected explicitly
        const isBillingContactChanging =
            formik.newBillingContact !== undefined &&
            formik.newBillingContact !== oldBillingContactIndex;

        // Check if the edited principal is now a billing contact (without using dropdown)
        const isEditingPrincipalBecomingBilling =
            formik.newBillingContact === undefined &&
            formik.principal.isBillingContact &&
            principalIndex !== oldBillingContactIndex;

        // Keep track if user selected the same billing contact from dropdown
        const isSameBillingContact =
            formik.newBillingContact !== undefined &&
            formik.newBillingContact === oldBillingContactIndex;

        currentPrincipals = currentPrincipals.map((principal, index) => {
            // Update the principal being edited
            if (index === principalIndex) {
                // If this principal is the same as the existing billing contact selected again from dropdown
                if (isSameBillingContact && index === oldBillingContactIndex) {
                    return { ...principal, ...formik.principal, isBillingContact: true };
                }
                return { ...principal, ...formik.principal };
            }

            // New Billing Contact selected via dropdown
            if (isBillingContactChanging) {
                if (index === formik.newBillingContact) {
                    return { ...principal, isBillingContact: true };
                }
                if (index === oldBillingContactIndex) {
                    return { ...principal, isBillingContact: false };
                }
            }

            // Edited principal manually set as billing contact (not via dropdown)
            if (isEditingPrincipalBecomingBilling) {
                if (index === principalIndex) {
                    return { ...principal, ...formik.principal, isBillingContact: true };
                }
                if (index === oldBillingContactIndex) {
                    return { ...principal, isBillingContact: false };
                }
            }

            // Keep other principals unchanged
            return principal;
        });

        // Rest of your message setting code remains the same
        if (isEditingPrincipalBecomingBilling) {
            const oldBillingContact =
                merchantDashboard.application.merchantInformation.principals[
                    oldBillingContactIndex
                ];
            setNewBillingContactMessage(
                `${formik.principal.firstName} ${formik.principal.lastName} contact details have been updated. ${oldBillingContact.firstName} ${oldBillingContact.lastName} is no longer the Billing Contact.`
            );
        } else if (!isEditingPrincipalBecomingBilling && isBillingContactChanging) {
            const newBillingContact =
                merchantDashboard.application.merchantInformation.principals[
                    formik.newBillingContact
                ];
            setNewBillingContactMessage(
                `${formik.principal.firstName} ${formik.principal.lastName} contact details have been updated. ${newBillingContact.firstName} ${newBillingContact.lastName} is the new Billing Contact.`
            );
        } else {
            setNewBillingContactMessage(
                `${formik.principal.firstName} ${formik.principal.lastName} contact details have been updated.`
            );
        }

        const updatedMerchantInformation = {
            ...merchantInformation,
            principals: currentPrincipals,
        };

        updatePrincipals({
            variables: {
                input: {
                    principalIndex,
                    applicationId: id,
                    merchantInformation: updatedMerchantInformation,
                },
            },
        });
    } else {
        if (formik.principal.isBillingContact) {
            currentPrincipals = currentPrincipals.map((principal) => {
                return {
                    ...principal,
                    isBillingContact: false,
                };
            });
        }
        const updatedMerchantInformation = {
            ...merchantInformation,
            principals: [
                ...currentPrincipals,
                {
                    ...formik.principal,
                    addresses: [],
                    isBeneficialOwner: false,
                    percentageOfOwnership: 0,
                    position: '',
                },
            ],
        };
        updatePrincipals({
            variables: {
                input: {
                    applicationId: id,
                    merchantInformation: updatedMerchantInformation,
                },
            },
        });
    }
};
